import React from 'react';
import styles from './index.module.scss';

import { ReactComponent as CaretIcon } from 'assets/img/icons/caret.svg';

export default function DropdownIndicator({
  isOpen = false,
  disabled = false,
  hasValue = false
}) {
  return (
    <CaretIcon
      data-open={isOpen}
      data-filled={hasValue}
      data-disabled={disabled}
      className={styles.container}
    />
  );
}
